module.exports = __webpack_public_path__ + "static/media/event_slide_3.f21e49e7.png";